// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Breach Contributors

import { useCallback, useState } from 'react';
import { Upload } from 'lucide-react';

export default function DropZone() {
  const [dragActive, setDragActive] = useState(false);

  const onDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setDragActive(true);
  }, []);

  const onDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setDragActive(false);
  }, []);

  const onDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setDragActive(false);
    const files = Array.from(e.dataTransfer.files);
    // eslint-disable-next-line no-console
    console.log('Dropped files:', files.map((f) => f.name));
  }, []);

  return (
    <div
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      className={`flex w-full max-w-2xl flex-col items-center justify-center rounded-2xl border-2 border-dashed p-16 transition-colors ${
        dragActive ? 'border-white bg-breach-700' : 'border-neutral-600 bg-breach-800'
      }`}
    >
      <Upload className="mb-4 h-12 w-12 text-neutral-400" />
      <p className="text-lg font-medium">Drag & drop files here</p>
      <p className="mt-2 text-sm text-neutral-400">All processing happens in your browser.</p>
    </div>
  );
}
